<template>
  <div>
    <div v-if="items.length === 0" class="text-center py-5 my-3">
      <img
        src="@/assets/images/empty-brandbranch-selection.png"
        alt="No selected brand / branch"
        class="img-fluid img-max-width">
      <b-row class="justify-content-center">
        <b-col lg="3" md="4">
          <p class="mb-0 no-selected-brandbranch">Add any brand and branch in Pre-Order Schedule Setting.</p>
        </b-col>
      </b-row>
    </div>
    <div v-else class="p-2">
      <div v-for="(brand, brandIndex) in items" :key="`brand_${brandIndex}`"
        :class="{ 'mb-4': brandIndex !== items.length - 1 }">
        <b-button
          v-b-toggle="`schedule-${brandIndex}`"
          variant="ghost"
          block
          class="text-left text-dark border d-flex justify-content-between collapse-trigger"
          :disabled="!enabled">
          {{ brand.brand_name }}
          <span>
            <span class="branches-count mr-2">{{ `${brand.branches.length} branch${brand.branches.length > 1 ? 'es' : ''}` }}</span>
            <span class="when-closed"><img src="../../assets/images/caret-right-2.svg" alt="caret-right"></span>
            <span class="when-open"><img src="../../assets/images/caret-left-2.svg" alt="caret-left"></span>
          </span>
        </b-button>
        <b-collapse :id="`schedule-${brandIndex}`" class="collapse-body">
          <b-card>
            <div v-for="(branch, branchIndex) in brand.branches" :key="`branch_${branchIndex}`"
              :class="['branch-item px-3 py-2 d-flex align-items-center justify-content-between', { 'border-bottom': branchIndex !== brand.branches.length - 1 }]">
              {{ branch.name }}
              <b-button
                variant="outline-primary"
                pill
                @click="handleSetupPreOrderingLink({
                  branch_uuid: branch.uuid,
                  brand_uuid: brand.brand_uuid
                })">
                Set up Pre Order Setting
              </b-button>
            </div>
          </b-card>
        </b-collapse>
      </div>
    </div>
    <FulfillmentSaveChangesModal :store="store" :origin="origin" />
  </div>
</template>

<script>
import FulfillmentSaveChangesModal from "./SaveFulfillmentChangesModal";

export default {
  name: "ScheduleSelectorComponent",
  props: ["items", "origin", "enabled"],
  components: { FulfillmentSaveChangesModal },
  data() {
    return {
      store: null
    }
  },
  methods: {
    handleSetupPreOrderingLink(data) {
      const isShowSaveAlert = this.$router.app.$children[0].$children.find(child => child.$el.id === 'fulfillment-container').isShowSaveAlert;
      
      if (!isShowSaveAlert) this.$router.push({ name: `Fulfillment${this.origin}PreOrdering`, params: { brand_uuid: data.brand_uuid, branch_uuid: data.branch_uuid } });
      else {
        this.store = data;
        this.$root.$emit('bv::show::modal', 'fulfillment-save-changes-modal');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.img-max-width {
  max-width: 140px;
}
p.no-selected-brandbranch {
  color: #87929D;
  font-size: 14px;
}
.collapse-trigger {
  font-size: 16px;
  font-family: MainFontBold, sans-serif;
  color: #2F3941;
  &:not(.collapsed) {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  .when-open > img {
    transform: rotate(-90deg);
  }
  .branches-count {
    font-size: 14px;
    color: #68737D;
  }
}
.collapse-trigger.collapsed > span .when-open {
  display: none;
}
.collapse-trigger:not(.collapsed) > span .when-closed {
  display: none;
}
.collapse-body .card {
  border-top: 0;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  & > .card-body {
    padding: 0;
  }
  .branch-item {
    font-size: 14px;
    color: #68737D;
    .btn.btn-outline-primary {
      border-radius: 20px;
    }
  }
}
</style>
